/* ===== Подключение компонентов React ===== */
import React, { useMemo, useState } from "react";

/* ===== Подключение локальных компонентов ===== */
import Card from "./Card";

/* ===== Подключение стилей ===== */
import s from "./CardsSection.module.scss";



export default function CardsSection({
  id,
  title,
  subtitle,
  grid = { cols: { base: 1, sm: 2, lg: 4 }, gap: "var(--spacing-4)" },
  items = [],
  onOrder,
}) {
  if (!items?.length) return null;

  const style = {
    "--cols-base": grid?.cols?.base ?? 1,
    "--cols-sm": grid?.cols?.sm ?? 2,
    "--cols-lg": grid?.cols?.lg ?? 4,
    "--gap": grid?.gap ?? "var(--spacing-4)",
  };

  return (
    <section id={id} className={s.section}>
      {(title || subtitle) && (
        <div className={s.head}>
          {title && <h2 className={s.h2}>{title}</h2>}
          {subtitle && <p className={s.sub}>{subtitle}</p>}
        </div>
      )}

      <div className={s.grid} style={style}>
        {items.map((item) => (
          <CardItem key={item.id} item={item} onOrder={onOrder} />
        ))}
      </div>
    </section>
  );
}

function CardItem({ item, onOrder  }) {
  // ✅ один вход, три “шаблона” по type
  if (item.type === "media") {
    return (
      <Card hover padding="md">
        {item.image?.src && (
          <Card.Media
            src={item.image.src}
            alt={item.image.alt || ""}
            overlay={Boolean(item.overlay)}
          />
        )}

        <Card.Body>
          <Card.Title>{item.title}</Card.Title>
          {item.text && <Card.Text>{item.text}</Card.Text>}
        </Card.Body>

        <Card.Footer>
          {item.price && <Card.Price>{item.price}</Card.Price>}

          {item.button?.href && (
            <Card.Button as="a" href={item.button.href} variant="primary">
              {item.button.label || "Подробнее"}
            </Card.Button>
          )}
        </Card.Footer>
      </Card>
    );
  }

  if (item.type === "icon") {
    return (
      <Card hover>
        <Card.Header>
          {item.icon && <Card.Icon>{item.icon}</Card.Icon>}
          {item.badge && <Card.Badge>{item.badge}</Card.Badge>}
        </Card.Header>

        <Card.Body>
          <Card.Title>{item.title}</Card.Title>
          {item.text && <Card.Text>{item.text}</Card.Text>}
        </Card.Body>

        {item.button?.href && (
          <Card.Footer>
            <Card.Actions>
              <Card.Button as="a" href={item.button.href} variant="primary">
                {item.button.label || "Открыть"}
              </Card.Button>
            </Card.Actions>
          </Card.Footer>
        )}
      </Card>
    );
  }

{/* === Карточки для блока Проблемы === */}
  if (item.type === "problem") {
  return (
    <Card hover className={s.problemCard}>
      <Card.Icon className={s.problemIcon}>
        {item.Icon ? <item.Icon className={s.problemSvg} /> : null}
      </Card.Icon>

      <Card.Body className={s.problemBody}>
        <Card.Title className={s.problemTitle}>{item.title}</Card.Title>
        {item.text && <Card.Text className={s.problemText}>{item.text}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

{ /* === Карточки для блока Решение проблем === */ }
if (item.type === "advantage") {
  return (
    <Card hover className={s.advCard}>
      <Card.Icon className={s.advIcon}>
        {item.Icon ? <item.Icon className={s.advSvg} /> : null}
      </Card.Icon>

      <Card.Body className={s.advBody}>
        <Card.Title className={s.advTitle}>{item.title}</Card.Title>
        {item.text && <Card.Text className={s.advText}>{item.text}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

{/* === Карточки для onlimeGsm === */}
if (item.type === "onlimeGsm") {
  return (
    <Card hover className={s.onlimeCard}>
      <Card.Body className={s.onlimeBody}>
        <Card.Title className={s.onlimeTitle}>{item.title}</Card.Title>
        {item.text && <Card.Text className={s.onlimeText}>{item.text}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

{/* === Карточки для Comands === */}
if (item.type === "team") {
  return (
    <Card hover className={s.teamCard} padding="md">
      {item.photo && (
        <Card.Media
          src={item.photo}
          alt={item.name || "Сотрудник"}
          className={`${s.teamMedia} ${item.imgSize === "small" ? s.teamMediaSmall : ""}`}
        />
      )}

      <Card.Body className={s.teamBody}>
        <Card.Title className={s.teamName}>{item.name}</Card.Title>
        {item.position && <div className={s.teamPosition}>{item.position}</div>}
        {item.text && <Card.Text className={s.teamText}>{item.text}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

{/* === Карточки для блока Акции / Лучшие предложения === */}
if (item.type === "product") {
  return <ProductCard item={item} onOrder={onOrder} />;
}




  // default: simple
  return (
    <Card hover>
      <Card.Body>
        <Card.Title>{item.title}</Card.Title>
        {item.text && <Card.Text>{item.text}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

function ProductCard({ item, onOrder}) {
  const [qty, setQty] = useState(1);

  const dec = () => setQty((v) => Math.max(1, v - 1));
  const inc = () => setQty((v) => v + 1);

  const total = useMemo(() => {
    const p = Number(item.pricePerLiter || 0);
    return (p * qty).toFixed(2);
  }, [item.pricePerLiter, qty]);

  return (
    <Card hover className={s.productCard} padding="md">
      {/* картинка + бейдж "картинка в картинке" */}
      {item.image?.src && (
        <div className={s.productMedia}>
          <Card.Media src={item.image.src} alt={item.image.alt || ""} overlay />
          {item.badge && <div className={s.productBadge}>{item.badge}</div>}
        </div>
      )}

      <Card.Body className={s.productBody}>
        <Card.Title className={s.productTitle}>{item.title}</Card.Title>

        {/* 5 звезд */}
        <div className={s.stars} aria-label="Рейтинг 5 из 5">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className={`${s.star} ${s.starOn}`} aria-hidden="true">
              ★
            </span>
          ))}
        </div>

        {item.text && <Card.Text className={s.productText}>{item.text}</Card.Text>}

        <div className={s.productMeta}>
          <div className={s.metaRow}>
            <span className={s.metaLabel}>В наличии:</span>
            <span className={s.metaValue}>{item.stock} поз.</span>
          </div>
          <div className={s.metaRow}>
            <span className={s.metaLabel}>Артикул:</span>
            <span className={s.metaValue}>{item.sku}</span>
          </div>
        </div>

        <div className={s.productPriceRow}>
          <div>
            <div className={s.priceLabel}>Цена за литр</div>
            <div className={s.priceValue}>
              {formatPrice(item.pricePerLiter)} ₽ <span className={s.per}>/л</span>
            </div>
          </div>

          <div className={s.qty}>
            <button type="button" className={s.qtyBtn} onClick={dec}>
              −
            </button>
            <div className={s.qtyValue}>{qty} л</div>
            <button type="button" className={s.qtyBtn} onClick={inc}>
              +
            </button>
          </div>
        </div>

        <div className={s.total}>
          <span className={s.totalLabel}>Итого:</span>
          <span className={s.totalValue}>{formatPrice(total)} ₽</span>
        </div>
      </Card.Body>

      <Card.Footer className={s.productFooter}>
        <Card.Actions className={s.productActions}>
          <Card.Button
           as="button"
           type="button"
           variant="primary"
            onClick={() => {
              onOrder?.(item, qty);
              document.querySelector("#leadFormBase")?.scrollIntoView({ behavior: "smooth" });
            }}
           >
            Оформить
          </Card.Button>
        </Card.Actions>
      </Card.Footer>
    </Card>
  );
}

function formatPrice(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return n;
  return num.toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

